export const PATHS = {
  DASHBOARD: '/',
  POST_MANAGEMENT: '/posts',
  DONOR_MANAGEMENT: '/donors',
  PAYMENT_STATUS: '/payments',
  PROJECT_MANAGEMENT: '/project',
  PROJECT_SETTINGS: '/project/settings',
  NEW_PROJECT: '/project/new',
  MY_ACCOUNT: '/account',
  LOGIN: '/login',
  SSO_CALLBACK: '/sso/callback',
  PASSWORD_FIND: '/password/find',
  DONATION_HISTORY_FIND: '/donation/find',
  SIGNUP: '/signup',
};

